import { JSX, ReactNode, createContext, useContext, useState } from 'react';
import * as vp from 'vopay';

export type ClientData = {
  Success: boolean | undefined;
  LoginUserName: string;
  AccountID: string;
  AccountName: string;
  Key: string;
  Signature: string;
  JWT: string;
  FirebaseToken: string;
  Country: string;
  GCMEnabled: string;
  EFTCollectEnabled: string;
  EFTSendEnabled: string;
  ACHFundEnabled: string;
  ACHWithdrawEnabled: string;
  USDEFTCollectEnabled: string;
  USDEFTSendEnabled: string;
  RTRWithdrawEnabled: string;
  RTPWithdrawEnabled: string;
  FedwireWithdrawEnabled: string;
  VisaDirectEnabled: string;
  InteracMoneyRequestEnabled: string;
  InboundEtransferEnabled: string;
  InteracBulkPayoutEnabled: string;
  PortalViewOnly: string;
  MoneyRequestGenerateUrlEnabled: string;
  SubAccountPermissions: string;
  ClientAccountsEnabled: string;
  clientAccountsEnabled: boolean;
  AutoBalanceTransferEnabled: string;
  TransactionLabelOverrideEnabled: string;
  IQ11StandardEnabled: string;
  IQ11BoostEnabled: string;
  IQ11PlusEnabled: string;
  IQ11AdvantageEnabled: string;
  TransactionServiceDefault: string;
  PayLinkEnabled: string;
  CustomFlinksCredentialsSet: boolean | undefined;
  CustomPlaidCredentialsSet: boolean | undefined;
  CustomInveriteCredentialsSet: boolean | undefined;
  EnablePaylinkDecline: string;
  CreditCardEnabled: string;
  GooglePayEnabled: boolean;
  UserManagementEnabled: string;
  AccountingSoftwareIntegrationEnabled: boolean;
  AccountingSystemIntegrationEnabled: string;
  AccountTransferEnabled: string;
  PushToCardEnabled: string;
  RealTimeMoneyRequestEnabled: string;
  CustomGlobalPaySharedSecret: boolean | undefined;
  KYCLightEnabled: string;
  AccountType: vp.ClientPortalAccountType;
  Domain: string;
  MFAEnabled: boolean | undefined;
  PasswordResetRequired: boolean | undefined;
  BrandingEmailEnabled: string;
  BrandingELinxEnabled: string;
  BrandingPortalEnabled: string;
  BrandingOnboardingEnabled: string;
  TransactionApprovalWorkflowEnabled: string;
  EmailDomainEnabled: string;
  ChatSupportEnabled: boolean;
  ParentAccountID: string;
  ParentAccountName: string;
  SubAccountType: string;
  InterestAccountEnabled: boolean;
  MicroDepositBankAccountVerificationEnabled: boolean;
  InteracVerificationEnabled: boolean;
  BillPayEnabled: boolean;
  AccountAndBillingEnabled: boolean;
  FundMyAccountEnabled: boolean;
  WithdrawMyAccountEnabled: boolean;
  BankAccountTransferEnabled: boolean;
  OperationalAccountsEnabled: boolean;
  PartnerBillsAccount: boolean;
  PaymentsEnabled: boolean;
  CollectionsEnabled: boolean;
  ShowSubAccountOrgChart: boolean;
  PushToCardProcessor: vp.PushToCardProcessor | '';
  CreditCardProcessor: vp.CreditCardProcessor | '';
  ACHFundingProcessor: vp.ACHFundingProcessor | '';
  ACHWithdrawProcessor: vp.ACHWithdrawProcessor | '';
  InteracMoneyRequestProcessor: vp.InteracMoneyRequestProcessor | '';
  InteracBulkPayoutProcessor: vp.InteracBulkPayoutProcessor | '';
  FedwireProcessor: vp.FedwireProcessor | '';
  RTPProcessor: vp.RTPProcessor | '';
  FednowProcessor: vp.FednowProcessor | '';
  InteracBasicVerificationEnabled: boolean;
  InteracEnhancedVerificationEnabled: boolean;
  CardBasicVerificationEnabled: boolean;
  CardEnhancedVerificationEnabled: boolean;
  SupportTicketEnabled: boolean;
  DigitalWalletsEnabled: boolean;
  PaypalWithdrawEnabled: boolean;
  VenmoWithdrawEnabled: boolean;
  FileConversionEnabled: boolean;
  FileSubmissionEnabled: boolean;
};
export type ClientDataCtx = {
  response: ClientData;
  setClientData: (ClientData: ClientData) => void;
  reset: () => void;
};

const defaults: ClientDataCtx = {
  response: {
    Success: false,
    LoginUserName: '',
    AccountID: '',
    AccountName: '',
    Key: '',
    Signature: '',
    JWT: '',
    FirebaseToken: '',
    Country: '',
    GCMEnabled: '',
    EFTCollectEnabled: '',
    EFTSendEnabled: '',
    ACHFundEnabled: '',
    ACHWithdrawEnabled: '',
    USDEFTCollectEnabled: '',
    USDEFTSendEnabled: '',
    RTRWithdrawEnabled: '',
    RTPWithdrawEnabled: '',
    FedwireWithdrawEnabled: '',
    VisaDirectEnabled: '',
    InteracMoneyRequestEnabled: '',
    InboundEtransferEnabled: '',
    InteracBulkPayoutEnabled: '',
    PortalViewOnly: '',
    MoneyRequestGenerateUrlEnabled: '',
    KYCLightEnabled: '',
    SubAccountPermissions: '',
    ClientAccountsEnabled: '',
    clientAccountsEnabled: false,
    AutoBalanceTransferEnabled: '',
    TransactionLabelOverrideEnabled: '',
    IQ11StandardEnabled: '',
    IQ11BoostEnabled: '',
    IQ11PlusEnabled: '',
    IQ11AdvantageEnabled: '',
    TransactionServiceDefault: '',
    PayLinkEnabled: '',
    CustomFlinksCredentialsSet: false,
    CustomPlaidCredentialsSet: false,
    CustomInveriteCredentialsSet: false,
    EnablePaylinkDecline: '',
    CreditCardEnabled: '',
    GooglePayEnabled: false,
    UserManagementEnabled: '',
    AccountingSoftwareIntegrationEnabled: false,
    AccountingSystemIntegrationEnabled: '',
    AccountTransferEnabled: '',
    PushToCardEnabled: '',
    RealTimeMoneyRequestEnabled: '',
    CustomGlobalPaySharedSecret: false,
    AccountType: 'Standard',
    Domain: '',
    MFAEnabled: false,
    PasswordResetRequired: false,
    BrandingEmailEnabled: '',
    BrandingELinxEnabled: '',
    BrandingPortalEnabled: '',
    BrandingOnboardingEnabled: '',
    TransactionApprovalWorkflowEnabled: '',
    EmailDomainEnabled: '0',
    ChatSupportEnabled: false,
    ParentAccountID: '',
    ParentAccountName: '',
    SubAccountType: '',
    InterestAccountEnabled: false,
    MicroDepositBankAccountVerificationEnabled: false,
    InteracVerificationEnabled: false,
    BillPayEnabled: false,
    AccountAndBillingEnabled: false,
    FundMyAccountEnabled: false,
    WithdrawMyAccountEnabled: false,
    BankAccountTransferEnabled: false,
    OperationalAccountsEnabled: false,
    PartnerBillsAccount: false,
    PaymentsEnabled: false,
    CollectionsEnabled: false,
    ShowSubAccountOrgChart: false,
    PushToCardProcessor: '',
    CreditCardProcessor: '',
    ACHFundingProcessor: '',
    ACHWithdrawProcessor: '',
    InteracMoneyRequestProcessor: '',
    InteracBulkPayoutProcessor: '',
    FedwireProcessor: '',
    RTPProcessor: '',
    FednowProcessor: '',
    InteracBasicVerificationEnabled: false,
    InteracEnhancedVerificationEnabled: false,
    CardBasicVerificationEnabled: false,
    CardEnhancedVerificationEnabled: false,
    SupportTicketEnabled: false,
    DigitalWalletsEnabled: false,
    PaypalWithdrawEnabled: false,
    VenmoWithdrawEnabled: false,
    FileConversionEnabled: false,
    FileSubmissionEnabled: false,
  },
  setClientData: () => {},
  reset: () => {},
};

export const ClientDataContext = createContext<ClientDataCtx>(defaults);

export const ClientDataProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [ClientData, setClientData] = useState<ClientData>(defaults.response);

  return (
    <ClientDataContext.Provider
      value={{
        response: ClientData,
        setClientData,
        reset: () =>
          setClientData({
            Success: false,
            LoginUserName: '',
            AccountID: '',
            AccountName: '',
            Key: '',
            Signature: '',
            JWT: '',
            FirebaseToken: '',
            Country: '',
            GCMEnabled: '',
            EFTCollectEnabled: '',
            EFTSendEnabled: '',
            ACHFundEnabled: '',
            ACHWithdrawEnabled: '',
            USDEFTCollectEnabled: '',
            USDEFTSendEnabled: '',
            RTRWithdrawEnabled: '',
            RTPWithdrawEnabled: '',
            FedwireWithdrawEnabled: '',
            VisaDirectEnabled: '',
            InteracMoneyRequestEnabled: '',
            InboundEtransferEnabled: '',
            InteracBulkPayoutEnabled: '',
            PortalViewOnly: '',
            MoneyRequestGenerateUrlEnabled: '',
            KYCLightEnabled: '',
            SubAccountPermissions: '',
            ClientAccountsEnabled: '',
            clientAccountsEnabled: false,
            AutoBalanceTransferEnabled: '',
            TransactionLabelOverrideEnabled: '',
            IQ11StandardEnabled: '',
            IQ11BoostEnabled: '',
            IQ11PlusEnabled: '',
            IQ11AdvantageEnabled: '',
            TransactionServiceDefault: '',
            PayLinkEnabled: '',
            CustomFlinksCredentialsSet: false,
            CustomPlaidCredentialsSet: false,
            CustomInveriteCredentialsSet: false,
            EnablePaylinkDecline: '',
            CreditCardEnabled: '',
            GooglePayEnabled: false,
            UserManagementEnabled: '',
            AccountingSoftwareIntegrationEnabled: false,
            AccountingSystemIntegrationEnabled: '',
            AccountTransferEnabled: '',
            PushToCardEnabled: '',
            RealTimeMoneyRequestEnabled: '',
            CustomGlobalPaySharedSecret: false,
            AccountType: 'Standard',
            Domain: '',
            MFAEnabled: false,
            PasswordResetRequired: false,
            BrandingEmailEnabled: '',
            BrandingELinxEnabled: '',
            BrandingPortalEnabled: '',
            BrandingOnboardingEnabled: '',
            TransactionApprovalWorkflowEnabled: '',
            EmailDomainEnabled: '0',
            ChatSupportEnabled: false,
            ParentAccountID: '',
            ParentAccountName: '',
            SubAccountType: '',
            InterestAccountEnabled: false,
            MicroDepositBankAccountVerificationEnabled: false,
            InteracVerificationEnabled: false,
            BillPayEnabled: false,
            AccountAndBillingEnabled: false,
            FundMyAccountEnabled: false,
            WithdrawMyAccountEnabled: false,
            BankAccountTransferEnabled: false,
            OperationalAccountsEnabled: false,
            PartnerBillsAccount: false,
            PaymentsEnabled: false,
            CollectionsEnabled: false,
            ShowSubAccountOrgChart: false,
            PushToCardProcessor: '',
            CreditCardProcessor: '',
            ACHFundingProcessor: '',
            ACHWithdrawProcessor: '',
            InteracMoneyRequestProcessor: '',
            InteracBulkPayoutProcessor: '',
            FedwireProcessor: '',
            RTPProcessor: '',
            FednowProcessor: '',
            InteracBasicVerificationEnabled: false,
            InteracEnhancedVerificationEnabled: false,
            CardBasicVerificationEnabled: false,
            CardEnhancedVerificationEnabled: false,
            SupportTicketEnabled: false,
            DigitalWalletsEnabled: false,
            PaypalWithdrawEnabled: false,
            VenmoWithdrawEnabled: false,
            FileConversionEnabled: false,
            FileSubmissionEnabled: false,
          }),
      }}
    >
      {children}
    </ClientDataContext.Provider>
  );
};

export const useClientData = (): ClientDataCtx => useContext(ClientDataContext);
